import { render, staticRenderFns } from "./editarRomaneioComItensNaoFicaramEmSaida.vue?vue&type=template&id=138cbf86&scoped=true&"
import script from "./editarRomaneioComItensNaoFicaramEmSaida.vue?vue&type=script&lang=js&"
export * from "./editarRomaneioComItensNaoFicaramEmSaida.vue?vue&type=script&lang=js&"
import style0 from "./editarRomaneioComItensNaoFicaramEmSaida.vue?vue&type=style&index=0&id=138cbf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cbf86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VDatePicker,VFlex,VForm,VLayout,VMenu,VSnackbar,VSpacer,VSwitch,VTextField})
